<template>
  <a-modal
    class="showMessage"
    v-model="visible"
    :title="title"
    :width="680"
    :maskClosable="false"
    :destroyOnClose="true"
    :confirmLoading="loading"
    okText="保存"
    wrapClassName="recommend-modal"
    @ok="save"
  >
    <a-form class="suitable-form" :form="form">
      <a-checkbox-group v-model="reason_text">
        <a-tabs @change="changeTab">
          <a-tab-pane tab="职能不符" key="FUNCTION" :forceRender="true">
            <div class="listtitle">职能不符，指的是猎头授权的简历，与岗位的招聘名称、职位类型、所属行业、技能不符，该标签将反馈给AI人工智能算法进行优化，请认真填写。</div>
            <div class="flex-div">
              <a-checkbox value="职位名称推荐不符" :checked="funcName.length!=0"></a-checkbox>
              <a-form-item label="职位名称推荐不符" :label-col="{ span: 5 }" :wrapperCol="{ span: 12, offset: 1 }">
                <a-auto-complete
                  placeholder="请填写职位名称"
                  :dataSource="funcNameData"
                  :disabled="reason_text.indexOf('职位名称推荐不符') == -1"
                  @search="chageFuncName"
                  @select="selectFunc"
                  v-decorator="[ `name`, ]"
                >
                  <template slot="dataSource">
                    <a-select-option v-for="(item,i) in funcNameData" :key="(item.third_category_name + i)">{{ item.third_category_name }}</a-select-option>
                  </template>
                </a-auto-complete>
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="职位类型推荐不符"></a-checkbox>
              <a-form-item label="职位类型推荐不符" :label-col="{ span: 5 }" :wrapperCol="{ span: 12, offset: 1 }">
                <a-cascader
                  :disabled="reason_text.indexOf('职位类型推荐不符') == -1"
                  changeOnSelect
                  :options="categoryId"
                  placeholder="请选择职位类型"
                  :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                  v-decorator="[ `category_id`, ]"
                />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="行业推荐不符"></a-checkbox>
              <a-form-item label="行业推荐不符" :label-col="{ span: 5 }" :wrapperCol="{ span: 12, offset: 1 }">
                <a-cascader
                  changeOnSelect
                  :disabled="reason_text.indexOf('行业推荐不符') == -1"
                  :options="industryId"
                  placeholder="请选择行业类型"
                  :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                  v-decorator="[ `industry_id`, ]"
                />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="职位技能不符"></a-checkbox>
              <a-form-item label="职位技能不符" :label-col="{ span: 5 }" :wrapperCol="{ span: 12, offset: 1 }">
                <a-input
                  readonly
                  :disabled="reason_text.indexOf('职位技能不符') == -1"
                  placeholder="请选择职位必备技能"
                  style="cursor:pointer;"
                  v-decorator="[ 'requirement_skill', ]"
                  @click="showTagsModal('requirement_skill')"
                />
              </a-form-item>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="雇主要求画像不符" key="PORTRAIT" :forceRender="true">
            <div class="listtitle">雇主要求画像不符，指的是雇主对候选人职能之外的要求，例如年龄、性别、工作经验学历等，该画像将影响职位对应的候选人画像筛选，请认真填写。</div>
            <div class="flex-div">
              <a-checkbox value="年龄不符要求"></a-checkbox>
              <a-form-item class="form-item" label="年龄不符要求" v-bind="formItemsLayout">
                <a-input
                  :disabled="reason_text.indexOf('年龄不符要求') == -1"
                  style="width:100px;"
                  addonAfter="岁"
                  v-decorator="[ 'draw_portrait_active_tag.active_age_min', ]"
                />
                <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">-</span>
                <a-input
                  :disabled="reason_text.indexOf('年龄不符要求') == -1"
                  style="width:100px;"
                  addonAfter="岁"
                  v-decorator="[ 'draw_portrait_active_tag.active_age_max', ]"
                />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="性别不符要求"></a-checkbox>
              <a-form-item class="form-item" label="性别不符要求" v-bind="formItemsLayout">
                <a-select v-decorator="[ 'gender_id' ]" placeholder="请选择性别" style="width:150px;" :disabled="reason_text.indexOf('性别不符要求') == -1" >
                  <a-select-option :value="1">男</a-select-option>
                  <a-select-option :value="2">女</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="工作经验不符要求"></a-checkbox>
              <a-form-item class="form-item" label="工作经验不符要求" v-bind="formItemsLayout">
                <a-input
                  :disabled="reason_text.indexOf('工作经验不符要求') == -1"
                  style="width:150px;"
                  addonAfter="年以上"
                  v-decorator="[ 'draw_portrait_active_tag.active_working_years', ]"
                />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="学历不符要求"></a-checkbox>
              <a-form-item class="form-item" label="学历不符要求" v-bind="formItemsLayout">
                <a-select v-decorator="[ 'education_id' ]" placeholder="请选择学历" style="width:230px;" :disabled="reason_text.indexOf('学历不符要求') == -1" >
                  <a-select-option :value="item.value" v-for="item in educationData" :key="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="出生地不符要求"></a-checkbox>
              <a-form-item class="form-item" label="出生地不符要求" v-bind="formItemsLayout">
                <a-cascader
                  :disabled="reason_text.indexOf('出生地不符要求') == -1"
                  style="width:230px;"
                  changeOnSelect
                  :options="area"
                  placeholder="请选择"
                  :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                  @click="() => loadData('nation')"
                  v-decorator="[ 'active_born' ]"
                />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="语言不符要求"></a-checkbox>
              <a-form-item label="语言不符要求"  v-bind="formItemsLayout">
                <a-checkbox-group v-decorator="['language_requirement']" :disabled="reason_text.indexOf('语言不符要求') == -1" >
                  <a-checkbox value="英语">英语</a-checkbox>
                  <a-checkbox value="普通话">普通话</a-checkbox>
                  <a-checkbox value="粤语">粤语</a-checkbox>
                  <a-checkbox value="日语">日语</a-checkbox>
                  <a-checkbox value="法语">法语</a-checkbox>
                  <a-checkbox value="其他">其他</a-checkbox>
                </a-checkbox-group>
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="频繁跳槽要求"></a-checkbox>
              <a-form-item class="form-item" label="频繁跳槽要求" v-bind="formItemsLayout" >
                <a-radio-group
                  :disabled="reason_text.indexOf('频繁跳槽要求') == -1"
                  :options='[{ label: "5年2跳", value: 1 }, { label: "5年3跳", value: 2 }]'
                  v-decorator="[ `draw_portrait_active_tag.active_job_hopping_interval`, ]"
                />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="生肖不符要求"></a-checkbox>
              <a-form-item class="form-item" label="生肖不符要求" v-bind="formItemsLayout" >
                <a-select v-decorator="[ 'draw_portrait_active_tag.active_zodiac_sign' ]" placeholder="请选择生肖" style="width:150px;" :disabled="reason_text.indexOf('生肖不符要求') == -1" >
                  <template v-for="(item, index) in zodiac">
                      <a-select-option :key="index+1" :value="index+1">{{ item }}</a-select-option>
                    </template>
                </a-select>
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="婚姻不符要求"></a-checkbox>
              <a-form-item class="form-item" label="婚姻不符要求" v-bind="formItemsLayout" >
                <a-radio-group
                  :disabled="reason_text.indexOf('婚姻不符要求') == -1"
                  :options='[{ label: "已婚", value: 2 }, { label: "未婚", value: 1 }]'
                  v-decorator="[ `draw_portrait_active_tag.active_is_married`, ]"
                />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="薪酬不符要求"></a-checkbox>
              <a-form-item class="form-item" label="薪酬不符要求" v-bind="formItemsLayout">
                <a-input
                  style="width:100px;"
                  :disabled="reason_text.indexOf('薪酬不符要求') == -1"
                  addonAfter="K"
                  v-decorator="[ 'draw_portrait_active_tag.active_salary_min', ]"
                >
                </a-input>
                <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">-</span>
                <a-input
                  style="width:100px;"
                  :disabled="reason_text.indexOf('薪酬不符要求') == -1"
                  addonAfter="K"
                  v-decorator="[ 'draw_portrait_active_tag.active_salary_max', ]"
                >
                </a-input>
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="证书不符要求"></a-checkbox>
              <a-form-item class="form-item" label="证书不符要求" v-bind="formItemsLayout" >
                <a-input placeholder="请输入证书" style="width:230px;" v-decorator="[ 'draw_portrait_active_tag.active_certificate', ]" :disabled="reason_text.indexOf('证书不符要求') == -1"   />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="第一学历不符要求"></a-checkbox>
              <a-form-item class="form-item" label="第一学历不符要求" v-bind="formItemsLayout" >
                <a-radio-group
                  :disabled="reason_text.indexOf('第一学历不符要求') == -1"
                  :options='[{ label: "统招本科", value: 0 }, { label: "统招985/211", value: 3 }]'
                  v-decorator="[ `draw_portrait_active_tag.active_school_type`, ]"
                />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="管理团队不符要求"></a-checkbox>
              <a-form-item class="form-item" label="管理团队不符要求" v-bind="formItemsLayout" >
                <a-input placeholder="" style="width:230px;"  v-decorator="[ 'draw_portrait_active_tag.active_manage_people', ]" addonAfter="人以上" :disabled="reason_text.indexOf('管理团队不符要求') == -1" />
              </a-form-item>
            </div>
            <div class="flex-div">
              <a-checkbox value="目标公司不符要求"></a-checkbox>
              <a-form-item class="form-item" label="目标公司不符要求" v-bind="formItemsLayout" >
                <a-auto-complete
                  class="company"
                  placeholder="请填写公司名称"
                  :disabled="reason_text.indexOf('目标公司不符要求') == -1"
                  v-model="firstCompanyName"
                  :dataSource="dataFirstCompanyName"
                  @change="changeFirstCompanyName"
                  @select="addCompanyData"
                />
                <div class="company-list" v-if="firstObjective.length > 0">
                  <div v-for="(item, i) in firstObjective" :key="i">
                    <div class="company-name">
                      {{ item.company_name }}
                      <div class="delete-com" @click="deleteFirstCompany(i)">
                        <a-icon type="close" />
                      </div>
                    </div>
                    <div style="clear: both"></div>
                    <div class="addProduct">
                      添加产品：
                      <template v-for="tag in item.productList">
                        <a-checkable-tag
                          style="border: #35B5FE 1px solid;"
                          :key="tag"
                          :checked="item.selectedProductList.indexOf(tag) > -1"
                          @change="checked => handleChangeProduct(tag, checked, i)"
                        >{{ tag }}</a-checkable-tag>
                        <!--<Tags :tag="tag" :selectedProductList="item.selectedProductList"></Tags>-->
                      </template>
                    </div>
                    <div class="addProduct">
                      添加备注：
                      <a-input placeholder="请填写备注" v-model="item.notes" />
                    </div>
                  </div>
                </div>
              </a-form-item>
            </div>
            <div class="flex">
              <a-checkbox value="其他原因" style=""></a-checkbox>
              <a-form-item class="textarea-limit form-item" label="其他原因" v-bind="formItemsLayout">
                <a-textarea
                  :disabled="reason_text.indexOf('其他原因') == -1"
                  placeholder="其他原因"
                  :rows="6"
                  v-decorator="[
                    'reason'
                  ]"
                ></a-textarea>
              </a-form-item>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-checkbox-group>

    </a-form>

    <TagsModal ref="tagsModal" :tagList="skillsTag" @ok="updateSkills"></TagsModal>

  </a-modal>
</template>

<script>
import Api from "@/api";
import TagsModal from "@/app/admin/post/tags-modal";
var timer;

export default {
  name: "suitable",
  props: ["authorized_id", "getResumeList"],
  components: {
    TagsModal
  },
  data() {
    return {
      title: "",
      status: "",
      visible: false,
      loading: false,
      form: this.$form.createForm(this),
      formItemsLayout: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 19,
        },
      },
      activeTab: 'FUNCTION',
      salary: undefined,
      reason: undefined,
      showPrice: false,
      options: [],
      workExperienceData: [
        { label: "不限", value: "0" },
        { label: "1年以下", value: "1" },
        { label: "1-3年", value: "2" },
        { label: "3-5年", value: "3" },
        { label: "5-10年", value: "4" },
        { label: "10-15年", value: "5" },
        { label: "15年以上", value: "6" }
      ],
      educationData: [
        { label: "不限", value: "0" },
        { label: "博士", value: "1" },
        { label: "MBA/EMBA", value: "2" },
        { label: "硕士", value: "3" },
        { label: "本科", value: "4" },
        { label: "大专", value: "5" },
        { label: "高中/中专", value: "6" }
      ],
      zodiac: ["鼠","牛","虎","兔","龙","蛇","马","羊","猴","鸡","狗","猪"],
      timer: null,
      area: [],
      funcName: '',
      funcNameData: [],
      industryData: [],
      categoryId: [{ name: "职能", id: 0 }],
      industryId: [{ name: "行业", id: 0 }],
      list: {
        nation: {
          fun: "getCityTree",
          key: "tree",
          init: { name: "全国", id: 0 }
        },
        post: {
          fun: "getPostTree",
          key: "tree",
          init: { name: "职能", id: 0 }
        },
        industry: {
          fun: "getIndustryTree",
          key: "tree",
          init: { name: "行业", id: 0 }
        }
      },
      skillsTag: [],
      firstObjective: [],
      firstCompanyName: "",
      dataFirstCompanyName: [],
      reason_text: [], // 选择按钮
    };
  },
  created() {
    this.loadData('nation');
    this.loadData('post');
    this.loadData('industry');
  },
  methods: {
    changeTab(val) {
      this.activeTab = val;
    },
    onChange(val) {
      this.reason_text = val;
    },
    handleChangeProduct(tag, checked, i) {
      const selectedProductList = this.firstObjective[i].selectedProductList;
      const nextSelectedTags = checked
        ? [...selectedProductList, tag]
        : selectedProductList.filter(t => t !== tag);
      if (nextSelectedTags.length === 4) {
        this.$message.info("最多只能添加三个");
      } else {
        this.firstObjective[i].selectedProductList = nextSelectedTags;
      }
    },
    addCompanyData(value, options) {
      this.firstCompanyName = value;
      this.onAddFirstCompany();
    },
    onAddFirstCompany() {
      if (this.firstObjective.length === 3) {
        this.$message.info("最多只能添加三个");
      } else if (this.firstCompanyName) {
        this.searchProducts(this.firstCompanyName).then(values => {
          let productList = [];
          let productListall = [];
          let name = this.firstCompanyName;
          values.list &&
            values.list.forEach(item => {
              productList.push(item.product_name);
              productListall.push(item);
            });
          this.firstObjective.push({
            company_name: name,
            productList: productList,
            productListall: productListall,
            selectedProductList: [],
            notes: ""
          });
          this.firstCompanyName = "";
        });
      }
    },
    searchProducts(value) {
      return Api.common.searchProducts({ keyword: value }).then(res => {
        return res;
      });
    },
    changeFirstCompanyName(value) {
      if (value.length >= 2) {
        this.debounce(() => this.getCompanyListApi(value), 1000);
      } else {
        this.dataFirstCompanyName = [];
      }
    },
    getCompanyListApi(value) {
      Api.common.getCompanyList({ keyword: value }).then(res => {
        const data = [];
        res.list.forEach(item => {
          data.push(item.name);
        });
        this.dataFirstCompanyName = data;
      });
    },
    debounce(fn, delay) {
      let self = this;
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(self);
      }, delay);
    },
    deleteFirstCompany(i) {
      this.firstObjective.splice(i, 1);
    },
    async showTagsModal(type) {
      let category_id = this.form.getFieldValue('category_id');
      if(category_id) {
        let lastCategoryId = category_id[2] || category_id[1] || category_id[0];
        let { skills } = await Api.common.getSkills({ function_id: lastCategoryId });
        skills.forEach( item => { item.is_default = '0' });
        this.skillsTag = skills;
        this.$refs.tagsModal.show(this.skillsTag, type);

      } else  {
        this.$message.info('请先选择职位类型！');
      }

    },
    updateSkills(skills, type) {
      // 处理skills选中的项目
      console.log(skills);
      let selectSkills = [];
      let str = '';
      selectSkills = selectSkills.concat(skills.filter( skill => ((skill.is_default === '1'))));
      selectSkills.forEach( item => {
        str += item.skill_name + ',';
      })
      str = str.slice(0, str.length -1);
      console.log(type+'-------', str);
      this.form.setFieldsValue({ 'requirement_skill': str });
    },
    selectFunc(value, opt) {
      this.funcName = value.substr(0, value.length - 1);
    },
    chageFuncName(value) {
      if(value.length > 0) {
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          Api.common.getFuncName({ name: value }).then( res => {
            this.funcNameData = res.list;
          })
        }, 1000);
      }
    },
    async getOptions() {
      let response;
      try {
        response = await Api.common.getCityTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.options = response.tree;
      this.options.forEach(item => {
        item.children.forEach( _item =>{
          delete _item.children;
        })
      });

    },
    async getIndustry() {
      let response;
      try {
        response = await Api.common.getIndustryTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.industryData = [...response.tree];
    },
    async loadData(type) {
      let data = this.list[type];
      let response;
      try {
        response = await Api.common[data.fun]();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      if (type == "nation") {
        this.area = this.joinData(response[data.key]);
      } else if (type == "post") {
        this.categoryId = this.joinData(response[data.key]);
      } else {
        this.industryId = this.joinData(response[data.key]);
      }
    },
    joinData(data) {
      let init = this.area;
      return [{ ...init }, ...data];
    },
    save() {
      this.form.validateFields( (err, values) => {
        if (!err) {
          this.loading = true;
          console.log(values);
          console.log(this.reason_text);
          values.first_category_id = values.category_id && values.category_id[0] || undefined;
          values.second_category_id = values.category_id && values.category_id[1] || undefined;
          values.third_category_id = values.category_id && values.category_id[2] || undefined;

          values.first_industry_id = values.industry_id && values.industry_id[0] || undefined;
          values.second_industry_id = values.industry_id && values.industry_id[1] || undefined;
          values.third_industry_id = values.industry_id && values.industry_id[2] || undefined;
          values.fourth_industry_id = values.industry_id && values.industry_id[3] || undefined;

          values.draw_portrait_active_tag.active_born_province_id = values.active_born && values.active_born[0] || undefined;
          values.draw_portrait_active_tag.active_born_city_id = values.active_born && values.active_born[1] || undefined;
          values.draw_portrait_active_tag.active_born_dist_id = values.active_born && values.active_born[2] || undefined;

          delete values.category_id;
          delete values.industry_id;
          delete values.active_born;
          let direction_companys = [];
          this.firstObjective.forEach(item => {
            const products = [];
            item.productListall.forEach(items => {
              if (item.selectedProductList.indexOf(items.product_name) > -1) {
                items.domain = items.product_domain;
                items.name = items.product_name;
                items.tags = items.product_tags;
                products.push(items);
              }
            });
            direction_companys.push({
              company_name: item.company_name,
              intention_order: 1,
              notes: item.notes,
              products: products
            });
          });

          let params = {
            post_id: this.record.id,
            elimination_type: this.activeTab,
            elimination_reason: JSON.stringify({
              ...values,
              direction_companys: direction_companys,
              reason_text: this.reason_text
            })
          };
          //关闭订单
          if (this.title === "关闭订单") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.close(params);
              } catch (e) {}
              resolve();
              this.close();
              this.$emit("ok");
            });
          }
          //投递审核拒绝
          if (this.record.status === "DELIVER") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.deliveryAuditFail(params);
              } catch (e) {}
              resolve();
              this.close();
              this.$emit("ok");
            });
          }
          //审核不通过
          if (this.record.status === "CREATED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.auditFail(params);
              } catch (e) {}
              resolve();
              this.close();
              this.$emit("ok");
            });
          }
          //推荐不通过
          if (this.record.status === "AUDIT_PASSED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.submitFail(params);
              } catch (e) {}
              resolve();
              this.close();
              this.$emit("ok");
            });
          }
          //未入职
          if (this.record.status === "OFFERED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.enteredFail(params);
              } catch (e) {}
              resolve();
              this.close();
              this.$emit("ok");
            });
          }
          //不过保
          if (this.record.status === "ENTERED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.completedFail(params);
              } catch (e) {}
              resolve();
              this.close();
              this.$emit("ok");
            });
          }
          //面试不通过
          if (this.record.status === "INTERVIEW") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.interviewConfirmFailed(params);
              } catch (e) {}
              resolve();
              this.close();
              this.$emit("ok");
            });
          }
        }
      })

    },
    show(record) {
      this.record = record;
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.loading = false;
      this.reason_text = [];
      this.form.resetFields();
    },
  }
};
</script>

<style lang="scss" scoped="scoped">
.showMessage {
  .ant-modal-title {
    text-align: center;
  }
  .listtitle {
    margin-bottom: 10px;
    margin-top: 10px;
    // color: #35b5fe;
  }
  .row-content {
    margin-left: 10px;
    .col {
      width: 100%;
      margin-bottom: 10px;
      .active {
        color: #35b5fe;
      }
    }
  }
  .salaryInput {
    display: inline-block;
    width: 100px;
  }
  .form-item {
    margin-bottom: 10px;
    // width: 350px;
  }
  .flex {
    display: flex;
    ::v-deep .ant-checkbox-wrapper {
      margin: 10px 10px 0 0;
    }
    ::v-deep .ant-form-item {
      flex: 1;
      margin-bottom: 0;
    }
    ::v-deep .ant-form-item-label {
      text-align: left;
    }
  }
  .flex-div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    ::v-deep .ant-checkbox-wrapper {
      margin-right: 10px;
    }
    ::v-deep .ant-form-item {
      flex: 1;
      margin-bottom: 0;
    }
    ::v-deep .ant-form-item-label {
      text-align: left;
    }
  }

  .company-list {
    padding: 10px;
    border: #ededed 1px solid;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .company-name {
    padding: 2px 5px;
    background: deepskyblue;
    margin-top: 10px;
    color: white;
    float: left;
    border-radius: 4px;
    position: relative;
    .delete-com {
      position: absolute;
      right: -8px;
      top: -8px;
      border-radius: 50%;
      line-height: 16px;
      text-align: center;
      background: red;
      color: white;
      width: 16px;
      height: 16px;
      font-size: 10px;
      cursor: pointer;
    }
  }
  .addProduct {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .tags-list {
    width: 100%;
    .tags-info {
      max-width: 600px;
    }
    div {
      float: left;
    }
    .item-title {
      color: black;
      font-weight: bold;
    }
  }
}
</style>
